import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogVisibilityBannerDropdownContentItemIcon from './VeltCommentDialogVisibilityBannerDropdownContentItemIcon/VeltCommentDialogVisibilityBannerDropdownContentItemIcon';
import VeltCommentDialogVisibilityBannerDropdownContentItemLabel from './VeltCommentDialogVisibilityBannerDropdownContentItemLabel/VeltCommentDialogVisibilityBannerDropdownContentItemLabel';
import { transformWireframeProps } from '../../../../../../utils/propUtils';
;
var VeltCommentDialogVisibilityBannerDropdownContentItem = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-visibility-banner-dropdown-content-item-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogVisibilityBannerDropdownContentItem.Icon = VeltCommentDialogVisibilityBannerDropdownContentItemIcon;
VeltCommentDialogVisibilityBannerDropdownContentItem.Label = VeltCommentDialogVisibilityBannerDropdownContentItemLabel;
export default VeltCommentDialogVisibilityBannerDropdownContentItem;
